module.exports = __webpack_public_path__ + "a3433eb9a01b776e1d5bf56fa8fa71f3.svg";